module.exports = __webpack_public_path__ + "static/media/benefit-fast.46aaf7cf.png";